(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

jQuery(document).ready(function () {

	var currentParams = location.href.split('?')[1];
	var params = currentParams.split('&');
	var configData = JSON.parse(sessionStorage.getItem('configData'));

	if (configData == null || configData == undefined || configData == 'undefined' || configData.model !== params[0].split('=')[1]) {
		var configData = {};
		configData.model = params[0].split('=')[1];
		configData.length = params[1].split('=')[1];
		configData.floorplan = params[2].split('=')[1];
		sessionStorage.setItem('configData', JSON.stringify(configData));
		localStorage.setItem('configData', JSON.stringify(configData));
	}

	configData.configStep = 'decor';
	sessionStorage.setItem('configData', JSON.stringify(configData));
	localStorage.setItem('configData', JSON.stringify(configData));

	var $containers = $('.card-floorplan');

	if ($containers.length <= 1) {
		setTimeout(function () {
			$containers[0].click();
			$($containers[0]).addClass('card-disabled');
		}, 350);
	}

	jQuery('.pl-modal-gallery').click(function () {
		if ($(this).hasClass('active')) {
			$('.pl-gallery-grid-wrapper').hide();
			$(this).removeClass('active');
		} else {
			jQuery('.pl-gallery-grid-wrapper').show();
			$(this).addClass('active');
		}
	});

	//Explore Modal
	$(".pl-explore-modal-trigger").click(function (e) {
		e.stopPropagation();

		var selectedId = $(this).parent().parent().parent().attr('data-id');
		var dataNum = $(this).attr("data-img");
		var imgToShow = $("#img" + dataNum).attr("src");

		$(".pl-explore-modal").fadeIn();
		$('body,html').css('overflow-y', 'hidden');
		$('.m-hotspot-carousel-slides').slick('unslick');

		var selectedIndex;

		$('.pl-explore-modal .pl-modal-content').each(function (index) {
			if ($(this).attr('data-id') == selectedId) {
				$(this).show();
				$(this).children().children().children().children().children().children(".modalImage").attr("src", imgToShow);
			} else {
				$(this).hide();
			}
		});
	});

	jQuery('.card-floorplan').click(function (e) {
		e.preventDefault();

		if ($(this).hasClass('card-disabled')) {
			return false;
		}

		$('.selected-card').children('.card-floorplan-upper').children('.pl-check-container').children('input').prop('checked', false);
		$('.selected-card').removeClass('selected-card');

		$(this).addClass('selected-card');

		if (jQuery(this).children('.card-floorplan-upper').children('.pl-check-container').children('input').prop('checked')) {
			jQuery(this).children('.card-floorplan-upper').children('.pl-check-container').children('input').prop('checked', false);
			$(this).removeClass('selected-card');
		} else {
			jQuery(this).children('.card-floorplan-upper').children('.pl-check-container').children('input').prop('checked', true);
		}

		// if(jQuery(this).siblings('.selected-card')){
		// 	jQuery(this).siblings('.selected-card').children('.card-floorplan-upper').children('.pl-check-container').children('input').prop('checked', false);
		// 	jQuery(this).siblings('.selected-card').removeClass('selected-card');
		// }

		var currentParams = location.href.split('?')[1];
		var selectedDecor = jQuery(this).attr('data-id');
		//console.log(selectedDecor);
		var newParams = currentParams + '&decor=' + selectedDecor;

		var configData = JSON.parse(sessionStorage.getItem('configData'));

		configData.decor = selectedDecor;

		sessionStorage.setItem('configData', JSON.stringify(configData));
		localStorage.setItem('configData', JSON.stringify(configData));

		jQuery('.pl-navNextBtn, .btn-next').attr('href', '/configurator/tt/options/' + buildURLParams());

		jQuery('.pl-navNextBtn, .btn-next').removeClass('disabled');
	});

	jQuery('.swap-interior').click(function (e) {
		//$('.pl-modal-content .bg-night.button-reset').click();
		if ($(this).hasClass('is-selected')) {
			return;
		}

		$('.is-selected').removeClass('is-selected');
		jQuery('.pl-swap-exterior').hide();
		if (jQuery('.m-hotspot-carousel-hotspot-content-wrap').hasClass('active-out')) {
			jQuery('.m-hotspot-carousel-hotspot-content-wrap').removeClass('active-out');
			jQuery(this).parent().parent().parent().siblings('.m-hotspot-carousel-hotspot-content-wrap').children('button.button-reset').click();
		}
		$(this).addClass('is-selected');
		jQuery('.pl-swap-interior').show();
	});

	jQuery('.swap-exterior').click(function (e) {
		//$('.pl-modal-content .bg-night.button-reset').click();
		if ($(this).hasClass('is-selected')) {
			return;
		}

		$('.is-selected').removeClass('is-selected');
		jQuery('.pl-swap-interior').hide();
		if (jQuery('.m-hotspot-carousel-hotspot-content-wrap').hasClass('active-out')) {
			jQuery('.m-hotspot-carousel-hotspot-content-wrap').removeClass('active-out');
			jQuery(this).parent().parent().parent().siblings('.m-hotspot-carousel-hotspot-content-wrap').children('button.button-reset').click();
		}
		$(this).addClass('is-selected');
		jQuery('.pl-swap-exterior').show();
	});

	jQuery('.pl-swap-interior').on('click', '.hotspot', function (e) {
		e.preventDefault();
		jQuery('.m-hotspot-carousel-hotspot-content-wrap').addClass('active-out');
		jQuery('.exterior-detail-wrap').hide();
		jQuery('.interior-detail-wrap').show();
	});

	jQuery('.pl-swap-exterior').on('click', '.hotspot', function (e) {
		e.preventDefault();
		jQuery('.m-hotspot-carousel-hotspot-content-wrap').addClass('active-out');
		jQuery('.interior-detail-wrap').hide();
		jQuery('.exterior-detail-wrap').show();
	});

	jQuery('.m-hotspot-carousel-hotspot-content-wrap button.button-reset').click(function (e) {
		jQuery('.m-hotspot-carousel-hotspot-content-wrap').removeClass('active-out');
	});

	jQuery('.pl-zoom-modal-trigger').click(function (e) {
		imgToShow = $(this).children('img').attr('src');
		$('.pl-zoom-modal .pl-modal-content img').attr('src', imgToShow);
	});

	//Swatch Modal
	$(".pl-swatch-modal-trigger").click(function (e) {
		e.stopPropagation();
		$('html').css('overflow-y', 'hidden');
		if (window.innerWidth <= 1000) {
			$('.pl-swatch-modal-mobile').addClass('activate');
		} else {
			$('.pl-swatch-modal-desktop').addClass('activate');
		}
		var target = $(this).attr('data-id');
		$('.pl-swatch-modal .pl-modal-content').hide();
		$('.' + target).show();
		$('.' + target).children('.pl-modal-slider').each(function (index) {
			$(this).slick({
				infinite: false,
				touchThreshold: 70
			});
		});
	});

	$(".pl-swatch-modal .pl-modal-close").click(function () {
		$(".pl-swatch-modal").removeClass("activate");
		$('.pl-swatch-modal .slick-initialized').each(function (index) {
			$(this).slick('unslick');
		});
		$('html').css('overflow-y', 'scroll');
		$('.pl-swatch-modal .pl-modal-content').hide();
	});
});

},{}]},{},[1]);
